import { Routes } from '@angular/router';
import { MainComponent } from './core/layouts/main/main.component';

export const routes: Routes = [
    {
      path: "newsletter",
      pathMatch: "full",
      loadComponent: () => import('./pages/newsletter/newsletter.component').then(m => m.NewsletterComponent)
    },
    {
      path: "download",
      pathMatch: "full",
      loadComponent: () => import('./pages/download/download.component').then(m => m.DownloadComponent)
    },
    {
      path: "",
      component: MainComponent,
      children: [
        {
          path: "",
          pathMatch: "full",
          loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
        },
        {
          path: "about-us",
          loadComponent: () => import('./pages/about-us/about-us.component').then(m => m.AboutUsComponent)
        },
        {
          path: "contact",
          loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent)
        },
        {
          path: "customer-support",
          loadComponent: () => import('./pages/customer-support/customer-support.component').then(m => m.CustomerSupportComponent)
        },
        {
          path: "legal-notices",
          loadComponent: () => import('./pages/legal-notices/legal-notices.component').then(m => m.LegalNoticesComponent)
        },
        {
          path: "project-management",
          loadComponent: () => import('./pages/project-management/project-management.component').then(m => m.ProjectManagementComponent)
        },
        {
          path: "qoezion/recruit",
          loadComponent: () => import('./pages/qoezion/recruit/recruit.component').then(m => m.RecruitComponent)
        },
        {
          path: "qoezion/plan",
          loadComponent: () => import('./pages/qoezion/plan/plan.component').then(m => m.PlanComponent)
        },
        {
          path: "qoezion/communication",
          loadComponent: () => import('./pages/qoezion/communication/communication.component').then(m => m.CommunicationComponent)
        },
        {
          path: "qoezion/map",
          loadComponent: () => import('./pages/qoezion/cartography/cartography.component').then(m => m.CartographyComponent)
        },
        {
          path: "qoezion/operational",
          loadComponent: () => import('./pages/qoezion/operational/operational.component').then(m => m.OperationalComponent)
        },
        {
          path: "qoezion/privacy-policy",
          loadComponent: () => import('./pages/qoezion/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
        },
        {
          path: "qoezion/terms-and-conditions",
          loadComponent: () => import('./pages/qoezion/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent)
        },
        {
          path: "qoezion",
          loadComponent: () => import('./pages/qoezion/qoezion.component').then(m => m.QoezionComponent)
        },
        {
          path: "qomeet",
          loadComponent: () => import('./pages/qomeet/qomeet.component').then(m => m.QomeetComponent)
        },
        {
          path: "customers",
          loadComponent: () => import('./pages/customers/customers.component').then(m => m.CustomersComponent)
        },
        {
          path: "customers/:id",
          loadComponent: () => import('./pages/customers/customers.component').then(m => m.CustomersComponent)
        },
        {
          path: "utmb-world-series",
          loadComponent: () => import('./pages/success-stories/utmb-world-series/utmb-world-series.component').then(m => m.UtmbWorldSeriesComponent)
        },
        {
          path: "les-ardentes",
          loadComponent: () => import('./pages/success-stories/les-ardentes/les-ardentes.component').then(m => m.LesArdentesComponent)
        },
        {
          path: "24h-du-mans",
          loadComponent: () => import('./pages/success-stories/24h-du-mans/24h-du-mans.component').then(m => m.LeMansComponent)
        },
        {
          path: "ffh",
          loadComponent: () => import('./pages/success-stories/ffh/ffh.component').then(m => m.FfhComponent)
        },
        {
          path: "cyclisme-piste",
          loadComponent: () => import('./pages/success-stories/cyclisme-piste/cyclisme-piste.component').then(m => m.CyclismePisteComponent)
        },
        {
          path: "federation-cyclisme",
          loadComponent: () => import('./pages/success-stories/federation-cyclisme/federation-cyclisme.component').then(m => m.FederationCyclismeComponent)
        },
        {
          path: "marathon-nantes",
          loadComponent: () => import('./pages/success-stories/marathon-nantes/marathon-nantes.component').then(m => m.MarathonNantesComponent)
        },
        {
          path: "courchevel-meribel-2023",
          loadComponent: () => import('./pages/success-stories/courchevel-meribel/courchevel-meribel.component').then(m => m.CourchevelMeribelComponent)
        },
        {
          path: "aluna-festival",
          loadComponent: () => import('./pages/success-stories/aluna-festival/aluna-festival.component').then(m => m.AlunaFestivalComponent)
        },
        {
          path: "musilac-festival",
          loadComponent: () => import('./pages/success-stories/musilac-festival/musilac-festival.component').then(m => m.MusilacFestivalComponent)
        },
        {
          path: "morzine-avoriaz",
          loadComponent: () => import('./pages/success-stories/morzine-avoriaz/morzine-avoriaz.component').then(m => m.MorzineAvoriazComponent)
        },
        {
          path: "grand-bornand",
          loadComponent: () => import('./pages/success-stories/grand-bornand/grand-bornand.component').then(m => m.GrandBornandComponent)
        },
        {
          path: "terms-and-conditions",
          loadComponent: () => import('./pages/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent)
        },
        // Redirections from previous website
        {
          path: "blog",
          redirectTo: '/qoezion',
        },
        {
          path: "actualites",
          redirectTo: '/',
        },
        {
          path: "references/aluna-festival",
          redirectTo: '/aluna-festival'
        },
        {
          path: "references",
          redirectTo: '/customers',
        },
        {
          path: "instants-benevoles",
          redirectTo: '/qoezion',
        },
        {
          path: "cool_timeline",
          redirectTo: '/',
        },
        {
          path: "la-societe",
          redirectTo: '/about-us',
        },
        {
          path: "solutions/qo-ezion",
          redirectTo: '/qoezion'
        },
        {
          path: "solutions/qo-pilot",
          redirectTo: '/project-management'
        },
        {
          path: "solutions",
          redirectTo: '/'
        },
        {
          path: "trouvez-votre-solution",
          redirectTo: '/'
        },
        {
          path: "contact-form",
          redirectTo: '/contact'
        },
        {
          path: "mentions-legales",
          redirectTo: '/legal-notices'
        },
        {
          path: "faq",
          redirectTo: '/'
        },
        // Not Found - 404     
        {
          path: "not-found",
          loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
        }
      ]
    },
    {
      path: "**",
      redirectTo: '/not-found',
      pathMatch: "full"
    }
  ];
